import { Breadcrumbs, Container, Grid, Link, Typography } from '@material-ui/core'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import { useHistory} from 'react-router-dom'

const BreadcrumbsHistory = (props) => {
    const history = useHistory()
    return (
        <>
            <Container maxWidth="lg" >
                <Grid container>
                    <Grid item xs={12}>
                        <Breadcrumbs aria-label="breadcrumb">
                            {
                                props.navList.slice(0, props.navList.length - 1).map((item, index) => {
                                    var params = "";
                                    if (item.urlParams.length >= 1) {
                                        params = item.urlParams[0].value;
                                        for (var i = 1; i < item.urlParams.length; i++) {
                                            params += `&${item.urlParams[i].value}`;
                                        }
                                    }
                                    return (
                                        <Link key={index} color="inherit" onClick={() => history.push(item.urlParams.length > 0 ? `${item.path}/${params}` : item.path) }>
                                            {item.linkLegend}
                                        </Link>
                                    )
                                }
                                )
                            }
                            <Typography color="textPrimary">{props.navList[props.navList.length - 1].linkLegend}</Typography>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const mapStateToProps = state => ({
    navList: state.NavigationReducer.routeList
})

const mapDispatchToProps = dispatch => {
    return {
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsHistory)
